"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useImageConfig } from "../../../utils/ImageConfigProvider/ImageConfigProviderClient.js";
import { Link, Text } from "@nxt-costco-com/forge-components";
import { SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../Analytics/index.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { renderImageIcon } from "./lib.js";
function TextWithIcon({
  entry,
  externalLinkData,
  target
}) {
  var _a, _b, _c;
  const { imageDomainSwapConfig } = useImageConfig();
  if (!entry) return null;
  const hasExternalLinkWarning = ((_a = entry.link) == null ? void 0 : _a.external_site) ? true : false;
  const isPreserveSearchParms = !!entry.preserve_url_params;
  const {
    warningPrimaryButtonText,
    warningCloseButtonAriaLabelText,
    warningSecondaryButtonText,
    warningText,
    warningTitle
  } = externalLinkData || {};
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [entry.link.title]
        }
      },
      children: /* @__PURE__ */ jsx(
        Link,
        {
          sx: {
            display: "inline-block",
            width: "fit-content"
          },
          "aria-label": `${entry.link_alt_text} ${entry.link.title}`,
          dataPrivate: entry == null ? void 0 : entry.disable_third_party_tracking,
          hasExternalLinkWarning,
          href: (_b = entry.link) == null ? void 0 : _b.url,
          preserveSearchParams: isPreserveSearchParms,
          target,
          uniqueId: (_c = entry.link) == null ? void 0 : _c.title,
          warningCloseAriaLabel: warningCloseButtonAriaLabelText,
          warningPrimaryButtonText,
          warningSecondaryButtonText,
          warningText,
          warningTitle,
          children: /* @__PURE__ */ jsxs(
            CostcoBox,
            {
              sx: {
                display: "flex",
                gap: SpaceXs,
                alignItems: "center"
              },
              children: [
                entry.icon_image || entry.icon ? renderImageIcon(entry, imageDomainSwapConfig) : null,
                /* @__PURE__ */ jsx(
                  Text,
                  {
                    bold: entry.link_style === "bold",
                    italic: entry.link_style === "italic",
                    uniqueId: entry.link.title,
                    children: entry.link.title
                  }
                )
              ]
            }
          )
        }
      )
    }
  );
}
export {
  TextWithIcon
};
